<p-confirmDialog />

<!-- Dialog de detalhes da ausência -->
<p-dialog
  [header]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.DETALHES_AUSENCIA' | translate"
  [visible]="!!$ausenciaSelecionada()"
  (visibleChange)="fecharDetalhes()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  styleClass="w-full"
  [style]="{ maxWidth: '360px' }"
>
  @if ($ausenciaSelecionada(); as ausencia) {
  <div class="flex flex-column gap-3">
    <div class="flex gap-4">
      <div>
        <div class="text-xs text-color-secondary mb-1">{{ 'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.INICIO' | translate }}</div>
        <div class="font-medium">
          {{ formatarDataHora(ausencia.dataHoraInicio) }}
        </div>
      </div>
      <div>
        <div class="text-xs text-color-secondary mb-1">{{ 'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.FIM' | translate }}</div>
        <div class="font-medium">
          {{ formatarDataHora(ausencia.dataHoraFim) }}
        </div>
      </div>
    </div>
    <div>
      <div class="text-xs text-color-secondary mb-1">{{ 'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.MOTIVO' | translate }}</div>
      <div class="font-medium">{{ ausencia.motivo }}</div>
    </div>
  </div>
  }
</p-dialog>

@if (!$criandoAusencia()) {
<div class="card">
  <div class="mb-3">
    <p-button
      icon="pi pi-plus"
      [label]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.NOVA_AUSENCIA' | translate"
      severity="secondary"
      [outlined]="true"
      (click)="iniciarCriacao()"
    />
  </div>

  <div class="flex gap-2 mb-3">
    <p-iconfield class="flex-1">
      <p-inputicon styleClass="pi pi-search" />
      <input
        pInputText
        type="text"
        [ngModel]="pesquisa()"
        (ngModelChange)="pesquisa.set($event)"
        [placeholder]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.BUSCAR_POR_MOTIVO' | translate"
        class="w-full"
      />
    </p-iconfield>
  </div>

  <p-table
    [value]="$ausenciasFiltradas()"
    [tableStyle]="{ width: '100%' }"
    [paginator]="true"
    [rows]="rows()"
    [rowsPerPageOptions]="[5, 10, 25]"
    [loading]="$loading()"
    [paginatorDropdownAppendTo]="$paginatorDropdownAppendTo()"
    styleClass="p-datatable-sm p-datatable-hoverable-rows"
  >
    <ng-template #header>
      <tr>
        <th style="width: 5.5rem">{{ 'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.INICIO' | translate }}</th>
        <th style="width: 5.5rem">{{ 'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.FIM' | translate }}</th>
        <th style="width: 3rem"></th>
      </tr>
    </ng-template>
    <ng-template #body let-ausencia>
      <tr style="cursor: pointer" (click)="verDetalhes(ausencia)">
        <td style="white-space: nowrap">
          {{ formatarDataHora(ausencia.dataHoraInicio) }}
        </td>
        <td style="white-space: nowrap">
          {{ formatarDataHora(ausencia.dataHoraFim) }}
        </td>
        <td (click)="$event.stopPropagation()">
          <div class="flex align-items-center justify-content-end">
            <p-button
              [pTooltip]="'GLOBAL.EXCLUIR' | translate"
              icon="pi pi-trash"
              severity="danger"
              [text]="true"
              [rounded]="true"
              (click)="excluirAusencia(ausencia)"
            />
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="3" class="text-center p-3 text-500">
          {{ 'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.NENHUMA_AUSENCIA' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
} @if ($criandoAusencia()) {
<lib-ausencia-criar-editar
  [profissional]="profissional"
  (footerTemplateAction)="onFooterTemplate($event)"
  (salvo)="onAusenciaSalva()"
  (cancelar)="cancelarCriacao()"
/>
}
